// @ts-nocheck


import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchArticleTable, fetchArticleById, addArticle, updateArticle, removeArticle } from "../../api/articleApi";

// Async thunks for article operations

export const getArticles = createAsyncThunk(
  "article/getArticles",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchArticleTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getArticleById = createAsyncThunk(
  "article/getArticleById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchArticleById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createArticle = createAsyncThunk(
  "article/createArticle",
  async (newArticle: { title: string; content: string; author: string; status: string; folder_name: string; photo?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addArticle(newArticle);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editArticle = createAsyncThunk(
  "article/editArticle",
  async ({ id, updatedArticle }: { id: string; updatedArticle: { title: string; content: string; author: string; status: string; folder_name: string; photo?: string } }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateArticle(id, updatedArticle);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteArticle = createAsyncThunk(
  "article/deleteArticle",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeArticle(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Article Slice

const articleSlice = createSlice({
  name: "article",
  initialState: {
    articles: [] as any[],
    article: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all articles
      .addCase(getArticles.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.articles = action.payload;
      })
      .addCase(getArticles.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Get article by ID
      .addCase(getArticleById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.article = action.payload;
      })
      .addCase(getArticleById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create article
      .addCase(createArticle.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.articles.push(action.payload);
          state.status = true;
          state.msg = "Article created successfully.";
        } else {
          // // // console.log('article not an array');
        }
      })

      // Edit article
      .addCase(editArticle.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.articles)) {
          const index = state.articles.findIndex((article) => article.id === id);
          if (index !== -1) {
            state.articles[index] = data;
          }
          state.status = true;
          state.msg = "Article updated successfully.";
        } else {
          // // // console.log('article not an array');
        }
      })

      // Delete article
      .addCase(deleteArticle.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.articles)) {
          state.articles = state.articles.filter((article) => article.id !== action.payload);
          state.status = true;
          state.msg = "Article deleted successfully.";
        } else {
          // // // console.log('article not an array');
        }
      });
  },
});

export const { resetStatus } = articleSlice.actions;
export default articleSlice.reducer;
